export const BUSINESS_PAYMENT_PREFIX = '/business/payment/v1';
export const BULK_DISBURSE_PREFIX = '/channel/bulk-disbursement';
